/**
 * 运营 - OpenApi - 对接客户列表
 */
<template>
  <div class="openapi-client-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>OpenApi</el-breadcrumb-item>
      <el-breadcrumb-item>对接客户</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="应用名">
          <el-input
            v-model="formInline.clientName"
            placeholder="请输入应用名"
            clearable
            class="search-input"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无对接客户"
        style="width: 100%"
        border
      >
        <el-table-column prop="appId" label="应用 ID" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.appId)"
            >
              {{ scope.row.appId || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="appSecret" label="密钥" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.appSecret)"
            >
              {{ scope.row.appSecret || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="clientName" label="客户名称" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.clientName)"
            >
              {{ scope.row.clientName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createdAt || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="平台公钥" width="90" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              :loading="scope.row.platformKeyLoading"
              @click="viewPlatformPublicKey(scope.row)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="goDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
      </div>
    </el-card>

    <el-dialog
      title="平台 RSA 公钥"
      :visible.sync="platformKeyDialog.visible"
      width="640px"
      :close-on-click-modal="false"
    >
      <div v-loading="platformKeyDialog.loading" class="platform-key-content">
        <el-input
          v-model="platformKeyDialog.publicKey"
          type="textarea"
          :rows="8"
          readonly
          placeholder="暂无平台公钥"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="platformKeyDialog.visible = false">关闭</el-button>
        <el-button
          size="small"
          type="primary"
          :disabled="!platformKeyDialog.publicKey"
          @click="copyToClipboard(platformKeyDialog.publicKey)"
        >
          复制公钥
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination';
import { getOpenapiClientList, getOpenapiPlatformPublicKey } from '../../api/userMG';

function createDefaultForm() {
  return {
    page: 1,
    pageSize: 10,
    clientName: ''
  };
}

export default {
  name: 'OpenapiClientList',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      formInline: createDefaultForm(),
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      platformKeyDialog: {
        visible: false,
        loading: false,
        publicKey: ''
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      const params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize
      };
      if (this.formInline.clientName) {
        params.clientName = this.formInline.clientName;
      }
      getOpenapiClientList(params)
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.listData = data.items || data.list || data.records || [];
            this.pageparm.total = data.totalCount || data.total || data.count || 0;
            this.pageparm.page = data.page || this.formInline.page;
            this.pageparm.pageSize = data.pageSize || this.formInline.pageSize;
          } else {
            this.listData = [];
            this.pageparm.total = 0;
            this.$message.error((res && (res.msg || res.message)) || '获取对接客户列表失败');
          }
        })
        .catch((err) => {
          this.listData = [];
          this.pageparm.total = 0;
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '获取对接客户列表失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.getList();
    },
    reset() {
      this.formInline = createDefaultForm();
      this.pageparm.page = 1;
      this.getList();
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    goDetail(row) {
      if (!row || row.id == null) {
        this.$message.warning('记录信息不完整');
        return;
      }
      this.$router.push({
        path: '/oms/openapiClientDetail',
        query: {
          clientId: row.id,
          clientName: row.clientName || '',
          appId: row.appId || '',
          companyName: row.companyName || '',
          createdAt: row.createdAt || ''
        }
      });
    },
    viewPlatformPublicKey(row) {
      this.platformKeyDialog.visible = true;
      this.platformKeyDialog.loading = true;
      this.platformKeyDialog.publicKey = '';
      if (row) {
        this.$set(row, 'platformKeyLoading', true);
      }
      getOpenapiPlatformPublicKey()
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.platformKeyDialog.publicKey = data.platformPublicKey || '';
            if (!this.platformKeyDialog.publicKey) {
              this.$message.warning('平台公钥未配置');
            }
          } else {
            this.$message.error((res && (res.msg || res.message)) || '获取平台公钥失败');
          }
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '获取平台公钥失败');
        })
        .finally(() => {
          this.platformKeyDialog.loading = false;
          if (row) {
            this.$set(row, 'platformKeyLoading', false);
          }
        });
    },
    copyToClipboard(text) {
      const str = text != null && text !== '' ? String(text) : '';
      if (!str) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(str)
          .then(() => {
            this.$message.success('已复制');
          })
          .catch(() => {
            this.fallbackCopy(str);
          });
      } else {
        this.fallbackCopy(str);
      }
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.warning('复制失败');
      }
      document.body.removeChild(el);
    }
  }
};
</script>

<style scoped>
.openapi-client-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.platform-key-content {
  min-height: 120px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
.copyable-cell {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/openapiClientList.vue